import { useEffect, useState } from "react";
import { useAuth } from '../../Components/AuthContext/AuthContext'


const InitialAvatar = ({ isSmall }) => {
    const { userInfo } = useAuth();
    const [initials, setInitials] = useState('')

    useEffect(() => {
        getInitials()
    }, [userInfo]);

    const getInitials = () => {
        if (userInfo) {
            const ins = `${userInfo.first_name[0]}${userInfo.last_name[0]}`
            setInitials(ins.toUpperCase())
        }

    };

    // Custom styling for the initials avatar
    const avatarStyle = {
        width: isSmall ? '40px' : '300px',
        height: isSmall ? '40px' : '300px',
        borderRadius: '50%',
        background: 'var(--Gradients-03, linear-gradient(119deg, #21211e 16.76%, #716d6a 100.11%))',
        color: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: isSmall ? '16px' : '50px',     // Adjust the size of the initials
        fontWeight: 'bold',
        userSelect: 'none'
    };

    return (
        <div style={avatarStyle}>
            {initials}
        </div>
    );
};

export default InitialAvatar;
